import styled from 'styled-components';
import Colors from 'constants/Colors';
import { Link } from 'react-router-dom';

const LoginContainer = styled.div`
  position: relative;
  max-width: 800px;
  width: 80%;
  margin: 0 auto;
  flex-basis: 0;
  flex-grow: 1;

  @media screen and (max-width: 768px) {
    width: 100%;
    padding: 0 1rem;
  }
`;

export { LoginContainer };

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;

  @media screen and (min-width: 768px) {
    margin-top: 1rem;
    justify-content: center;
  }

  @media screen and (max-width: 768px) {
    margin-top: 1rem;
    justify-content: center;
  }
`;

export { ButtonContainer };

const TextStyled = styled.span`
  text-align: right;
  display: block;
  font-size: 14px;
  color: #6CBACA;
  margin-top: 0px;

  @media screen and (max-width: 768px) {
    text-align: center;
  }
`;

export { TextStyled };